import { v4 as uuid } from "uuid";
import { paragon } from "@useparagon/connect";
import type { IConnectSDK } from "@useparagon/connect";

export interface ParagonCredentials {
  integrationId: string;
  accountId: string;
  solutionId: string;
  userId: string;
  email: string;
  label: string;
}

export interface ParagonEvent {
  integrationType: string;
}

export interface ParagonData {
  client: IConnectSDK;
  paragonUserId: string;
  paragonRedirectOauthUrl: string;
}

interface ParagonResponse {
  projectId: string;
  token: string;
  paragonRedirectOauthUrl: string;
}

export const getParagon = async (
  authenticateBrowserUrl?: string,
  userId?: string,
): Promise<ParagonData | undefined> => {
  const paragonUserId = userId ?? uuid();
  const credentials = await getCredentials(
    paragonUserId,
    authenticateBrowserUrl,
  );

  if (credentials !== undefined) {
    try {
      await paragon.authenticate(credentials.projectId, credentials.token);
    } catch (err) {
      await paragon.authenticate(credentials.projectId, credentials.token);
    }

    return {
      client: paragon,
      paragonUserId,
      paragonRedirectOauthUrl: credentials.paragonRedirectOauthUrl,
    };
  }

  return undefined;
};

export const saveCredential = async (
  authUrl: string,
  credential: ParagonCredentials,
): Promise<{ credentialId: string }> => {
  const request = new Request(`${authUrl}/callback`, {
    headers: {
      "Content-Type": "application/json",
    },
    method: "POST",
    body: JSON.stringify(credential),
  });
  const resp = await fetch(request);

  return await resp.json();
};

const getCredentials = async (
  userId: string,
  authenticateBrowserUrl?: string,
): Promise<ParagonResponse | undefined> => {
  if (authenticateBrowserUrl === undefined) {
    return undefined;
  }

  const authUrl = `${authenticateBrowserUrl}?userId=${userId}`;
  const resp = await fetch(authUrl);
  const cred = await resp.json();

  return cred?.token === undefined
    ? undefined
    : {
        token: cred.token,
        projectId: cred.projectId,
        paragonRedirectOauthUrl: cred.paragonRedirectOauthUrl,
      };
};
